exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".venmo-info{background:#fff;color:tomato;border:1px solid tomato!important;font-size:1.15em;border-radius:4px;height:40px;min-height:40px;max-height:40px;max-width:750px;position:relative;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;border:none;vertical-align:top;cursor:pointer;overflow:hidden}.venmo{display:none;background:#fff;border-radius:8px;padding:1em;border:1px solid tomato!important}.venmo-show{display:block}", ""]);

// exports
